import React from 'react';
import MotionDiv from './motion';

const Layout = ({ children }) => {
  return (
    <div className="container-page py-16 sm:py-28">
      <MotionDiv>
        {children}
      </MotionDiv>
    </div>
  );
};

export default Layout;
